import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Orders.css";
import "../styles/Home.css";
import { isEmpty } from "../functions/isEmpty";
import { useLocation, useNavigate } from "react-router";
import VideoRecorder from "../components/VideoRecorder";
import Bottombar from "../components/Bottombar";

export default function Orders({
  isMobile,
  apiURL,
  authToken,
  creators,
  services,
  orders,
  companyData,
  isSeller,
  setIsSeller,
}) {
  let navigate = useNavigate();
  let location = useLocation().pathname;

  const [filteredOrders, setFilteredOrders] = useState([]);

  useEffect(() => {
    if (!isEmpty(orders) && !isEmpty(companyData)) {
      setFilteredOrders(filterByBuyerId(orders, companyData));
    }
  }, [orders, companyData]);

  function filterByBuyerId(array, companyData) {
    return array.filter((item) => item.buyer_id == companyData.id);
  }

  const handleNavigateClick = (destination) => {
    navigate(destination);
  };

  return (
    <div className="orders">
      {isMobile ? (
        <div> </div>
      ) : (
        <div className="orders_topnav">
          <div className="orders_topnav_left_title">Bestellungen </div>

          <div className="orders_topnav_right">
            {isEmpty(authToken) ? (
              <div
                className="orders_topnav_right_account button"
                onClick={() => handleNavigateClick("/login")}>
                Login
              </div>
            ) : (
              <>
                {!isEmpty(companyData) && companyData.isACreator == 0 ? (
                  <div
                    className="orders_topnav_right_account button"
                    onClick={() => handleNavigateClick("/menu")}>
                    Menu
                  </div>
                ) : (
                  <div
                    className="orders_topnav_right_account button"
                    onClick={() => handleNavigateClick("/sellerprofile")}>
                    {" "}
                    {!isEmpty(companyData) && companyData.instagramProfileURL}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
      {isMobile && <div className="orders_title">Deine Bestellungen</div>}
      <div className="orders_subTitle">
        {isEmpty(filteredOrders) && "Du hast bisher noch keine Bestellungen"}
      </div>
      <div className="orders_body">
        {filteredOrders.map((order) => (
          <div
            className="orders_body_listelement"
            onClick={() => navigate("/orders/" + order.id)}>
            <div className="orders_body_listelement_left">
              <img
                src={order.service_img_url}
                className="orders_body_listelement_left_img"
              />
            </div>
            <div className="orders_body_listelement_right">
              <div className="orders_body_listelement_right_top">
                {order.service_title} <br />
                {order.seller_name}
              </div>
              <div className="orders_body_listelement_right_top">
                {isEmpty(order.fulfillment_deliveryurl)
                  ? "In Bearbeitung"
                  : "Werbung Live!"}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 18px;
  color: #474747;
`;

const ArrowBack = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
`;
